import { Component, OnInit, computed, input, output } from '@angular/core';
import { IShopifySellingPlan, IShopifySellingPlanAllocation } from '@app/_shared/_models/shopify-subscription.model';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-subscription',
    templateUrl: './subscription.component.html',
    styleUrls: ['./subscription.component.scss'],
    imports: [MatRadioGroup, FormsModule, MatRadioButton]
})
export class SubscriptionComponent implements OnInit {
  readonly sellingPlans = input<Array<IShopifySellingPlan>>(new Array<IShopifySellingPlan>());
  readonly sellingAllocations = input<Array<IShopifySellingPlanAllocation>>(new Array<IShopifySellingPlanAllocation>());
  readonly originalPrice = input<number>(0);
  readonly selectedSubscription = output<string>();
  public selectedSubscriptionIndex = 0;

  // Reactively derive variant-specific prices from allocations.
  // This replaces the old ngOnInit mutation approach so prices
  // update correctly whenever inputs change.
  readonly planPrices = computed(() => {
    return this.sellingPlans().map(plan => {
      const allocation = this.sellingAllocations().find(a => a.sellingPlanId === plan.id);
      return allocation?.variantPriceAdjustments?.[0]?.price
        ?? plan.priceAdjustments?.[0]?.adjustmentValue?.price;
    });
  });

  ngOnInit(): void {
    if (this.sellingPlans().length > 0) {
      this.selectedSubscription.emit(this.sellingPlans()[0].id);
    }
  }

  public selectSubscription(subscriptionIndex: number): void {
    this.selectedSubscriptionIndex = subscriptionIndex;
    // If it equals the length of the array then we know the user
    // selected the "One-time purchase" option.
    const sellingPlans = this.sellingPlans();
    if (subscriptionIndex === sellingPlans.length) {
      this.selectedSubscription.emit('');
    } else {
      this.selectedSubscription.emit(sellingPlans[subscriptionIndex].id);
    }
  }

}
